__turbopack_context__.v({
  "card": "StoryCard-module-scss-module__R15q-q__card",
  "cardLink": "StoryCard-module-scss-module__R15q-q__cardLink",
  "content": "StoryCard-module-scss-module__R15q-q__content",
  "cta": "StoryCard-module-scss-module__R15q-q__cta",
  "ctaButton": "StoryCard-module-scss-module__R15q-q__ctaButton",
  "image": "StoryCard-module-scss-module__R15q-q__image",
  "overlay": "StoryCard-module-scss-module__R15q-q__overlay",
  "subtitle": "StoryCard-module-scss-module__R15q-q__subtitle",
  "tag": "StoryCard-module-scss-module__R15q-q__tag",
  "tagWrapper": "StoryCard-module-scss-module__R15q-q__tagWrapper",
  "title": "StoryCard-module-scss-module__R15q-q__title",
});
